/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchPixtaImageSuccessResponseData,
    SearchPixtaImageSuccessResponseDataFromJSON,
    SearchPixtaImageSuccessResponseDataFromJSONTyped,
    SearchPixtaImageSuccessResponseDataToJSON,
} from './SearchPixtaImageSuccessResponseData';

/**
 * GET /press_release/pixta/serch
 * @export
 * @interface SearchPixtaImageResponse
 */
export interface SearchPixtaImageResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchPixtaImageResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof SearchPixtaImageResponse
     */
    message: string;
    /**
     * 
     * @type {SearchPixtaImageSuccessResponseData}
     * @memberof SearchPixtaImageResponse
     */
    data: SearchPixtaImageSuccessResponseData;
}

export function SearchPixtaImageResponseFromJSON(json: any): SearchPixtaImageResponse {
    return SearchPixtaImageResponseFromJSONTyped(json, false);
}

export function SearchPixtaImageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPixtaImageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': SearchPixtaImageSuccessResponseDataFromJSON(json['data']),
    };
}

export function SearchPixtaImageResponseToJSON(value?: SearchPixtaImageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': SearchPixtaImageSuccessResponseDataToJSON(value.data),
    };
}

